import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEvent} from "@angular/common/http";
import { map } from 'rxjs/operators';
import { Observable ,BehaviorSubject} from 'rxjs';


import { Config } from "../../config/constants";
@Injectable({
  providedIn: 'root'
})
export class UserService {
  userAuthenticationDetails: any;
constructor(private http: HttpClient,private config:Config) { }

// dashboard
  getDashboardData(){
    return this.http.get<any>(`${this.config.dashboardapiurl}`)
    .pipe(
        // the backend service sends an instance of the user
        map(user => {
           
            return user;
        })
    );
}

getdocuments(){
  return this.http.get<any>(`${this.config.getdocument}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
        
          return user;
      })
  );
}
// payment module
getPaymentModuleDetails(leadId){
  return this.http.get<any>(`${this.config.getPaymentModuleDetails+leadId}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
        
          return user;
      })
  );
}
// payment history
getPaymentHistory(leadId:any,searchString:any, sortBy:any,sortDir:any,page:any,size:any){
  return this.http.get<any>(`${this.config.getPaymentHistory+leadId+'/'+searchString +'?sort=' +sortBy+','+sortDir+'&page='+page+'&size='+size}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
        
          return user;
      })
  );
}
getAgencydocuments(agencyId,leadId){
  return this.http.get<any>(`${this.config.getAgencydocument+agencyId+'/lead/'+leadId}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
        
          return user;
      })
  );
}

getLeadList(){
return this.http.get<any>(`${this.config.getLeadList}`)
.pipe(
  // the backend service sends an instance of the user
  map(user => {
     
      return user;
  })
);
}

getMGA(mgaId:any,page:any,size:any){
  // return this.http.get<any>(`${this.config.getMgaUnderLeads}`)
  return this.http.get<any>(`${this.config.getMgaUnderLeads+'/'+mgaId+'?page='+page+'&size='+size}`)
  .pipe(
    // the backend service sends an instance of the user
    map(user => {
       
        return user;
    })
  );
  }

  getMGAPage(page:any){
    return this.http.get<any>(`${this.config.getMgaUnderLeadsByPage}${page}`)
    .pipe(
      // the backend service sends an instance of the user
      map(user => {
         
          return user;
      })
    );
    }

    
  getNotification(){
    //    (this.config.forgetPasswor)
    return this.http.get<any>(`${this.config.getNotification}`)
    .pipe(
        map(user => {
            return user;
        })
    );
  }

  notificationAllRead(){
    return this.http.put<any>(`${this.config.readAllNotification}`,{})
    .pipe(
        map(data => {
            return data;
        })
    );
  }

  
  getNotificationByPage(page){
    //    (this.config.forgetPasswor)
    return this.http.get<any>(`${this.config.getNotification+'?page='+page}`)
    .pipe(
        map(user => {
            return user;
        })
    );
  }

  notificationRead(notificationId){
    return this.http.put<any>(`${this.config.notificationRead+notificationId}`,{})
    .pipe(
        map(data => {
            return data;
        })
    );
  }

    getLeadBySize(page:any,size: any){

      return this.http.get<any>(`${this.config.sizeWiseLeads+page+'&size='}${size}`)
      .pipe(
          // the backend service sends an instance of the user
          map(user => {
             
              return user;
          })
      );
    }

checkEmail(email:string){

  return this.http.get<any>(`${this.config.checkEmail}${email}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
         
          return user;
      })
  );
}
getLeadAgentsCodes(leadId:string){

  return this.http.get<any>(`${this.config.getLeadAgentsCodes}${leadId}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
         
          return user;
      })
  );
}
getOnlineTrainingDetails(leadId:string){

  return this.http.get<any>(`${this.config.getOnlineTrainingDetails}${leadId}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
         
          return user;
      })
  );
}

getContractInfo(leadsId){
  //    (this.config.forgetPasswor)
  return this.http.get<any>(`${this.config.getContractInfo+leadsId}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}

searchMgaDashboard(searchString: any){

  return this.http.get<any>(`${this.config.mgaSearch}${searchString}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
         
          return user;
      })
  );
}

logoutCall(refreshToken){
  //    (this.config.forgetPasswor)
  return this.http.post<any>(`${this.config.logoutapiurl}`,{refreshToken})
  .pipe(
      map(user => {
          return user;
      })
  );
}

getDocumentDetailsLead(leadId:string){

  return this.http.get<any>(`${this.config.getDocumentDetails}${leadId}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
         
          return user;
      })
  );
}

saveDocument(leadID){
  return this.http.get<any>(`${this.config.saveAllDocument}${leadID}`)
  .pipe(
    // the backend service sends an instance of the user
    map(user => {
       
        return user;
    })
  );
  }
getLeadMapping(){
  return this.http.get<any>(`${this.config.getLeadMappingList}`)
  .pipe(
    // the backend service sends an instance of the user
    map(user => {
       
        return user;
    })
  );
  }


  deleteDoc(documentId){ 
    return this.http.delete<any>(`${this.config.deleteDocument}${documentId}`)
    .pipe(
        map(user => {    
            return user;
        })
    );
  }

  deleteDocAgency(documentId){ 
    return this.http.delete<any>(`${this.config.deleteDocument}${documentId}`)
    .pipe(
        map(user => {    
            return user;
        })
    );
  }

  deleteLicens(documentId){ 
    return this.http.delete<any>(`${this.config.deleteLic}${documentId}`)
    .pipe(
        map(user => {    
            return user;
        })
    );
  }

  deleteLicensAgency(documentId){ 
    return this.http.delete<any>(`${this.config.deleteLic}${documentId}`)
    .pipe(
        map(user => {    
            return user;
        })
    );
  }

  updatePassword(oldPassword: any,newPassword: any){
    return this.http.post<any>(`${this.config.updatePassword}`, {oldPassword,newPassword})
    .pipe(
        map(user => {
            return user;
        })
    );
  }
 
  setnewPassword(password: any,confirmPassword: any,token: any){
    return this.http.post<any>(`${this.config.setnewPassword}`, {password,confirmPassword,token})
    .pipe(
        map(user => {
            return user;
        })
    );
  }

  updateProfile(email: any,firstName: any,lastName: any,middleName: any,phoneNumber: any){
    return this.http.post<any>(`${this.config.updateProfile}`, {email,firstName,lastName,middleName,phoneNumber})
    .pipe(
        map(user => {
            return user;
        })
    );
  }

  deleteVoidCheck(documentId){ 
    return this.http.delete<any>(`${this.config.deleteVoid}${documentId}`)
    .pipe(
        map(user => {    
            return user;
        })
    );
  }

  deleteVoidCheckAgency(documentId){ 
    return this.http.delete<any>(`${this.config.deleteVoidAgency}${documentId}`)
    .pipe(
        map(user => {    
            return user;
        })
    );
  }

  getContractSignOFLead(leadId){
    return this.http.get<any>(`${this.config.getContractSignOFLead}${leadId}`)
    .pipe(
      // the backend service sends an instance of the user
      map(user => {
         
          return user;
      })
    );
    }

    filterLeadsPost(brokerType:any,commitionType:any, fromDate:any,stageStatus:any,toDate:any,mgaId:any){
      return this.http.post<any>(`${this.config.filterLeads}`, {brokerType,commitionType, fromDate,stageStatus,toDate,mgaId})
      .pipe(
          // the backend service sends an instance of the user
          // user: any (because .post<any>)
          map(user => {
              // login successful if the response has jwt token
         
    
              return user;
          })
      );
    }
    
    getFilterData(){
      //  console.log(this.config.forgetPasswor)
      return this.http.get<any>(`${this.config.filterData}`)
      .pipe(
          map(user => {
              return user;
          })
      );
    }
    


addMember(firstName,
  middleName,
  lastName,
  languages,
  allProvicesList,
  primaryAddressCity,
  primaryAddressCountry,
  primaryAddressPostalCode,
  primaryAddressProvince,
  primaryCompleteAddress,
  workPhone,
  workPhoneExtension,
  alternativeAddressCity,
  alternativeAddressCountry,
  alternativeAddressPostalCode,
  alternativeAddressProvince,
  alternativeCompleteAddress,
  ciprnumber  ,
  emailAddress,
  mobileNumber,
  positionTitle,
  leadId,
  salutation,
  agencyMgaId,
  userId,
  leadStatus,
  type,
  website,
  isCompanySignup,
  companyName,myTravelLinkRequest,agencyId,socialInsuranceNumber,wfgCode){

  return this.http.post<any>(`${this.config.updateLEad}`, {firstName,
    middleName,
    lastName,
    languages,
    allProvicesList,
    primaryAddressCity,
    primaryAddressCountry,
    primaryAddressPostalCode,
    primaryAddressProvince,
    primaryCompleteAddress,
    workPhone,
    workPhoneExtension,
    alternativeAddressCity,
    alternativeAddressCountry,
    alternativeAddressPostalCode,
    alternativeAddressProvince,
    alternativeCompleteAddress,
    ciprnumber  ,
    emailAddress,
    mobileNumber,
    positionTitle,
    leadId,
    salutation,
    agencyMgaId,
    userId,
    leadStatus,
    type,
  website,
  isCompanySignup,
  companyName,myTravelLinkRequest,agencyId,socialInsuranceNumber,wfgCode})
  .pipe(
      // the backend service sends an instance of the user
      // user: any (because .post<any>)
      map(user => {
          // login successful if the response has jwt token
     

          return user;
      })
  );
}
addMemberAccount(firstName,
  middleName,
  lastName,
  languages,
  allProvicesList,
  primaryAddressCity,
  primaryAddressCountry,
  primaryAddressPostalCode,
  primaryAddressProvince,
  primaryCompleteAddress,
  workPhone,
  workPhoneExtension,
  alternativeAddressCity,
  alternativeAddressCountry,
  alternativeAddressPostalCode,
  alternativeAddressProvince,
  alternativeCompleteAddress,
  ciprnumber  ,
  emailAddress,
  mobileNumber,
  positionTitle,
  leadId,
  salutation,
  agencyMgaId,
  userId,
  leadStatus,
  type,
  website,
 ){

  return this.http.post<any>(`${this.config.updateLEad}`, {firstName,
    middleName,
    lastName,
    languages,
    allProvicesList,
    primaryAddressCity,
    primaryAddressCountry,
    primaryAddressPostalCode,
    primaryAddressProvince,
    primaryCompleteAddress,
    workPhone,
    workPhoneExtension,
    alternativeAddressCity,
    alternativeAddressCountry,
    alternativeAddressPostalCode,
    alternativeAddressProvince,
    alternativeCompleteAddress,
    ciprnumber  ,
    emailAddress,
    mobileNumber,
    positionTitle,
    leadId,
    salutation,
    agencyMgaId,
    userId,
    leadStatus,
    type,
  website,
  })
  .pipe(
      // the backend service sends an instance of the user
      // user: any (because .post<any>)
      map(user => {
          // login successful if the response has jwt token
     

          return user;
      })
  );
}

public submitFormService(url, FormData): Observable<HttpEvent<any>> {
  // let httpHeaders = new HttpHeaders({
  //   //'Content-Type' : 'multipart/form-data',
  //   //'Authorization': 'token eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJrVFpaNy00cE41RTlMZWVWMG13TXdDVUdBN2hWeUdHTlUwaFNFM0NnRUFXdXVoOW1XXzlNdl90YUQwUmhQeUVtSDRqSG5vYWxTNGZCWUNhbCJ9.6U4qEV8nhH0M_LTQ_KMlu4kXpWrexZEAOl09oitDI-M',
  //   'Authorization': 'token ' + JSON.stringify(sessionStorage.getItem('userToken')),
  
  //   //'Cache-Control': 'no-cache'
  // });
  // return this.http.post<any>(url, FormData, { headers: httpHeaders });
  return this.http.post<any>(url, FormData);
}
public submitFormService1(url, FormData): Observable<HttpEvent<any>> {
  // let httpHeaders = new HttpHeaders({
  //   //'Content-Type' : 'multipart/form-data',
  //   //'Authorization': 'token eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJrVFpaNy00cE41RTlMZWVWMG13TXdDVUdBN2hWeUdHTlUwaFNFM0NnRUFXdXVoOW1XXzlNdl90YUQwUmhQeUVtSDRqSG5vYWxTNGZCWUNhbCJ9.6U4qEV8nhH0M_LTQ_KMlu4kXpWrexZEAOl09oitDI-M',
  //   'Authorization': 'token ' + JSON.stringify(localStorage.getItem('userToken')),
  
  //   //'Cache-Control': 'no-cache'
  // });
  // return this.http.post<any>(url, FormData, { headers: httpHeaders });
  return this.http.post<any>(url, FormData);
}
public OverWriteEO(url, FormData): Observable<HttpEvent<any>> {
  // let httpHeaders = new HttpHeaders({
  //   //'Content-Type' : 'multipart/form-data',
  //   //'Authorization': 'token eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJrVFpaNy00cE41RTlMZWVWMG13TXdDVUdBN2hWeUdHTlUwaFNFM0NnRUFXdXVoOW1XXzlNdl90YUQwUmhQeUVtSDRqSG5vYWxTNGZCWUNhbCJ9.6U4qEV8nhH0M_LTQ_KMlu4kXpWrexZEAOl09oitDI-M',
  //   'Authorization': 'token ' + JSON.stringify(localStorage.getItem('userToken')),
  
  //   //'Cache-Control': 'no-cache'
  // });
  // return this.http.post<any>(url, FormData, { headers: httpHeaders });
  return this.http.post<any>(url, FormData);
}
updateAllDocument(leadId:string,licences: any,document: any){
  return this.http.post<any>(`${this.config.updateAllDocument}`, {leadId,licences,document})
  .pipe(
      map(user => {
          return user;
      })
  );
}
getLeadInfo(){
  //  console.log(this.config.forgetPasswor)
  return this.http.get<any>(`${this.config.getLeadInfo}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
checkphoneNumber(phoneNumber:number){

  return this.http.get<any>(`${this.config.checkphoneNumber}${phoneNumber}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
         
          return user;
      })
  );
}
getLeadsTags(){
  return this.http.get<any>(`${this.config.getTagsList}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
// Third Party
authorizeUser(email){
  return this.http.post<any>(`${this.config.authsmarterUserapiurl}`, {email})
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
         
          return user;
      })
  );
}
getSignerStatus(FormData){
  return this.http.post<any>(`${this.config.getSignerStatus}`, FormData)
.pipe( map(data => {
return data;
  })
);
}
updateEverSignStatus(leadId,signerRole){
  return this.http.put<any>(`${this.config.updateEverSignStatus}`, {leadId,signerRole})
  .pipe(
      map(data => {
          return data;
      })
  );
}
getLeadPreviewLink(fileId:any){
  //    (this.config.forgetPasswor)
  return this.http.get<any>(`${this.config.PreviewLink}${fileId}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
Forgetpassword(email:string,portal:string,isResetMyself:any){
  //    (this.config.forgetPasswor)
  return this.http.post<any>(`${this.config.forgetPassword}`, {email,portal,isResetMyself})
  .pipe(
      // the backend service sends an instance of the user
      // user: any (because .post<any>)
      map(user => {
          // login successful if the response has jwt token
         

          return user;
      })
  );
}
getMiscDocument(leadId){
  return this.http.get<any>(`${this.config.getLeadMiscellaneous+leadId}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
        
          return user;
      })
  );
}

getLeadInfoId(leadId:any){
  //    (this.config.forgetPasswor)
  return this.http.get<any>(`${this.config.LeadInfoId}${leadId}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getLeadSharedLink(fileId:any){
  //    (this.config.forgetPasswor)
  return this.http.get<any>(`${this.config.SharedLink}${fileId}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getExpiryDocListing(isDeactive,mgaId){
  //    (this.config.forgetPasswor)
  return this.http.get<any>(`${this.config.getExpiredDocs}${isDeactive+'/'+mgaId}`)
  .pipe(
      map(user => {
        return user;
      })
  );
}
getDocumentDetailsLeadEO(leadId:string){

  return this.http.get<any>(`${this.config.getDocumentDetailsOA}${leadId}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
         
          return user;
      })
  );
}

getProvincesBToB(){
  return this.http.get<any>(`${this.config.getProvinces}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}getLanguages

getLanguageBToB(){
  return this.http.get<any>(`${this.config.getLanguages}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getCountryDropdown(){
  return this.http.get<any>(`${this.config.getCountry}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getAddressCanada(purchaserAddress1){
  return this.http.get<any>(`${this.config.AddressCallCanada+purchaserAddress1+"?types=address&access_token=pk.eyJ1IjoidGVjaC10cmF2ZWxhbmNlIiwiYSI6ImNtOTc3MjB6NTA0a28yc3BxOWo1ZGtwZm8ifQ.jVlelsWJPgCitrVekZRT6g&streets=true&language=en&session_token=02e5c1ee-9e4d-4cf1-895d-20749d003310&country=ca"}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getAddressCanada1N(purchaserAddress1,purchaserAddress1c){
  return this.http.get<any>(`${this.config.AddressCallCanada+"Text="+purchaserAddress1+"&Container="+purchaserAddress1c+"&Origin="+"CAN"+"&Countries="+"CAN"+"&Datasets=&Filter=&Language=en&$block=true&$cache=true&SOURCE=PCA-SCRIPT&SESSION=3548a915-4b43-d9d3-762c-087d75ac7504"}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getAddressCanadaSelected(id){
  return this.http.get<any>(`${this.config.AddressCallCanadaSelect+id+"?session_token=02e5c1ee-9e4d-4cf1-895d-20749d003310&access_token=pk.eyJ1IjoidGVjaC10cmF2ZWxhbmNlIiwiYSI6ImNtOTc3MjB6NTA0a28yc3BxOWo1ZGtwZm8ifQ.jVlelsWJPgCitrVekZRT6g"}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getAddressCanadaSelected2(id){
  return this.http.get<any>(`${this.config.AddressCallCanadaSelect+id+"?session_token=02e5c1ee-9e4d-4cf1-895d-20749d003310&access_token=pk.eyJ1IjoidGVjaC10cmF2ZWxhbmNlIiwiYSI6ImNtOTc3MjB6NTA0a28yc3BxOWo1ZGtwZm8ifQ.jVlelsWJPgCitrVekZRT6g"}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getExpiryDocListingPage(isDeactive,page:any,mgaId){
  return this.http.get<any>(`${this.config.getExpiredDocs+isDeactive+'/'+mgaId+"?page="+page}`)
  .pipe(
    // the backend service sends an instance of the user
    map(user => {
       
        return user;
    })
  );
  }
  getExpiryDocListingPageSiize(isDeactive,page,size,mgaId){

    return this.http.get<any>(`${this.config.getExpiredDocs+isDeactive+'/'+mgaId+"?page="+page+'&size='+size}`)
    .pipe(
        // the backend service sends an instance of the user
        map(user => {
           
            return user;
        })
    );
  }

  getMGAPageBYSortAsc1(page:any,size,nametable){
    return this.http.get<any>(`${this.config.getMgaUnderLeadsByPage+'?page='+page+'&size='+size+'&sort='+nametable+',asc'}`)
    .pipe(
      map(user => {        
          return user;
      })
    );
  }

  getMGAPageBYSortDesc1(page:any,size,nametable){
    return this.http.get<any>(`${this.config.getMgaUnderLeadsByPage+'?page='+page+'&size='+size+'&sort='+nametable+',desc'}`)
    .pipe(
      map(user => {         
          return user;
      })
    );
    }
    getExpiryDocListingAsc1(isDeactive,page:any,size,nametable,mgaId){
      return this.http.get<any>(`${this.config.getExpiredDocs+isDeactive+'/'+mgaId+'?page='+page+'&size='+size+'&sort='+nametable+',asc'}`)
      .pipe(
          map(user => {
            return user;
          })
      );
    }
    getExpiryDocListingDesc1(isDeactive,page:any,size,nametable,mgaId){
      return this.http.get<any>(`${this.config.getExpiredDocs+isDeactive+'/'+mgaId+'?page='+page+'&size='+size+'&sort='+nametable+',desc'}`)
      .pipe(
          map(user => {
            return user;
          })
      );
    }
    searchMgaDashboardDoc(isDeactive,searchString){

      return this.http.get<any>(`${this.config.mgaSearchDocument+isDeactive+'/search/'+searchString}`)
      .pipe(
          // the backend service sends an instance of the user
          map(user => {
             
              return user;
          })
      );
    }
    getMoreInfoReqData(isDeactivate,mgaId){
      return this.http.get<any>(`${this.config.getMoreInfoData+isDeactivate+'/'+mgaId}`)
      .pipe(
          // the backend service sends an instance of the user
          map(user => {
            
              return user;
          })
      );
    }
    getExpiryDocListingAsc2(isDeactive,page:any,size,nametable,mgaId){
      return this.http.get<any>(`${this.config.getMoreInfoData+isDeactive+'/'+mgaId+'?page='+page+'&size='+size+'&sort='+nametable+',asc'}`)
      .pipe(
          map(user => {
            return user;
          })
      );
    }
    getExpiryDocListingDesc2(isDeactive,page:any,size,nametable,mgaId){
      return this.http.get<any>(`${this.config.getMoreInfoData+isDeactive+'/'+mgaId+'?page='+page+'&size='+size+'&sort='+nametable+',desc'}`)
      .pipe(
          map(user => {
            return user;
          })
      );
    }
    searchMgaMoreInfo(isDeactive,searchString){

      return this.http.get<any>(`${this.config.mgaSearchDocumentMoreInfo+isDeactive+'/search/'+searchString}`)
      .pipe(
          // the backend service sends an instance of the user
          map(user => {
             
              return user;
          })
      );
    }
    getExpiryDocListingPageMoreInfo(isDeactive,page:any,mgaId){
      return this.http.get<any>(`${this.config.getMoreInfoData+isDeactive+'/'+mgaId+"?page="+page}`)
      .pipe(
        // the backend service sends an instance of the user
        map(user => {
           
            return user;
        })
      );
      }
      getExpiryDocListingPageSiizeMoreInfo(isDeactive,page,size,mgaId){

        return this.http.get<any>(`${this.config.getMoreInfoData+isDeactive+'/'+mgaId+"?page="+page+'&size='+size}`)
        .pipe(
            // the backend service sends an instance of the user
            map(user => {
               
                return user;
            })
        );
      }
getLicenseRequestCall(leadId,docType){
        return this.http.get<any>(`${this.config.getLicenseRequested+leadId+'/'+docType}`)
        .pipe(
            // the backend service sends an instance of the user
            map(user => {
              
                return user;
            })
        );
      }
  
  searchMgaDashboardGlobal(searchString: any,page:any,size:any){
        // return this.http.get<any>(`${this.config.mgaSearchGlobal}${searchString}`)
        return this.http.get<any>(`${this.config.mgaSearchGlobal+searchString+'?page='+page+'&size='+size}`)
        .pipe(
            // the backend service sends an instance of the user
            map(user => {
                return user;
            })
        );
      }
    exportLeads(leadIds:any){
        return this.http.post<any>(`${this.config.exportLeads}`, {leadIds})
        .pipe(map(user => { return user;
        })
    );
  }
getPolicies(){
    return this.http.get<any>(`${this.config.getPoliciesHome}`)
    .pipe(map(user => { return user;
    })
  );
 }
 policySearch(effectiveEndDate,effectiveStartDate,agencyCode){
  return this.http.post<any>(`${this.config.getPoliciesSearch}`, {effectiveEndDate,effectiveStartDate,agencyCode})
  .pipe(map(user => { return user;
  })
);
}
getAllPolicyForSalesAdmin(){
  return this.http.get<any>(`${this.config.getAllPolicyForSalesAdmin}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getAllPolicyForSalesAdminByPage(page:any,size: any){
  return this.http.get<any>(`${this.config.getAllPolicyForSalesAdmin+'?page='+page+'&size='}${size}`)
  .pipe(map(data => {return data;}));
}
getAllPolicyForSalesAdminSortAsc(page:any,size: any,nametable){
return this.http.get<any>(`${this.config.getAllPolicyForSalesAdmin+'?page='+page+'&size='+size+'&sort='+nametable+',asc'}`)
 .pipe(map(user => {return user;}));
}
getAllPolicyForSalesAdminSortDesc(page:any,size: any,nametable){
 return this.http.get<any>(`${this.config.getAllPolicyForSalesAdmin+'?page='+page+'&size='+size+'&sort='+nametable+',desc'}`)
 .pipe(map(user => {return user;}));
}
getAllSavedQuotes(){
  return this.http.get<any>(`${this.config.getAllSavedQuotes}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getSavedQuoteByAgencyCode(agencyCode){
  return this.http.get<any>(`${this.config.getAllSavedQuotes+ '/' +agencyCode}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getAllSavedQuotesByAgentId(agentId){
  return this.http.get<any>(`${this.config.getAllSavedQuotesByAgentId+ '/' +agentId}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getSavedQuoteById(Id){
  return this.http.get<any>(`${this.config.getSavedQuotesById + Id}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
// getFilterSearchPolicy(agencyCode,policyNumber,lastName,firstName,effectiveStartDate,departureStartDate,departureEndDate,creditCardNumber,applicationStartDate,applicationEndDate){
//   return this.http.post<any>(`${this.config.getFilterSearchPolicyCall}`,{agencyCode,policyNumber,lastName,firstName,effectiveStartDate,departureStartDate,departureEndDate,creditCardNumber,applicationStartDate,applicationEndDate})
//   .pipe(map(user => {return user;}));
//  }
//  getFilterSearchPolicyByPage(agencyCode,policyNumber,lastName,firstName,effectiveStartDate,departureStartDate,departureEndDate,creditCardNumber,applicationStartDate,applicationEndDate,page:any,size: any){
//   return this.http.post<any>(`${this.config.getFilterSearchPolicyCall+'?page='+page+'&size='}${size}`,{agencyCode,policyNumber,lastName,firstName,effectiveStartDate,departureStartDate,departureEndDate,creditCardNumber,applicationStartDate,applicationEndDate})
//   .pipe(map(user => {return user;}));
//  }
//  getFilterSearchPolicyByPageAsc(agencyCode,policyNumber,lastName,firstName,effectiveStartDate,departureStartDate,departureEndDate,creditCardNumber,applicationStartDate,applicationEndDate,page:any,size: any,nametable){
//   return this.http.post<any>(`${this.config.getFilterSearchPolicyCall+'?page='+page+'&size='+size+'&sort='+nametable+',asc'}`,{agencyCode,policyNumber,lastName,firstName,effectiveStartDate,departureStartDate,departureEndDate,creditCardNumber,applicationStartDate,applicationEndDate})
//   .pipe(map(user => {return user;}));
//  }
//  getFilterSearchPolicyByPageDsc(agencyCode,policyNumber,lastName,firstName,effectiveStartDate,departureStartDate,departureEndDate,creditCardNumber,applicationStartDate,applicationEndDate,page:any,size: any,nametable){
//   return this.http.post<any>(`${this.config.getFilterSearchPolicyCall+'?page='+page+'&size='+size+'&sort='+nametable+',desc'}`,{agencyCode,policyNumber,lastName,firstName,effectiveStartDate,departureStartDate,departureEndDate,creditCardNumber,applicationStartDate,applicationEndDate})
//   .pipe(map(user => {return user;}));
//  }
getSearchResult(searchCriteria:any,page:any,size:any,nametable?:any){
  let url = `${this.config.getFilterSearchPolicyCallNew}?page=${page}&size=${size}`;
  if(nametable != null)
    url = url+'&sort='+nametable;

  return this.http.post<any>(url, searchCriteria)
  .pipe(
      map(data => {
          return data;
      })
  );
}
getFilterSearchPolicy(agencyCode,policyNumber,lastName,firstName,effectiveStartDate,departureStartDate,departureEndDate,creditCardNumber,applicationStartDate,applicationEndDate){
  return this.http.post<any>(`${this.config.getFilterSearchPolicyCallNew}`,{agencyCode,policyNumber,lastName,firstName,effectiveStartDate,departureStartDate,departureEndDate,creditCardNumber,applicationStartDate,applicationEndDate})
  .pipe(map(user => {return user;}));
 }
 getAllPolicyForSalesAdminBySize(page:any,size:any){
  return this.http.get<any>(`${this.config.getAllPolicyForSalesAdminBySize+page+'&size='}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}

 getPolicyById1(id){
  return this.http.get<any>(`${this.config.getPolicyByIdSelected}`+id)
  .pipe(
      map(user => {
          return user;
      })
  );
}

getViewCocCheck(id){
  return this.http.get<any>(`${this.config.getPolicyCoc1}`+id)
  .pipe(
      map(user => {
          return user;
      })
  );
}
emailSendStart(email,policyId){
  return this.http.post<any>(`${this.config.getPolicyEmailSend}`,{email,policyId})
  .pipe(map(user => { return user;
  })
);
}
refundCallApi(adminFee,amount,prevAmount,policyId,txnId,refundReason,cardInfo){
  return this.http.post<any>(`${this.config.getRefundTxnApi}`,{adminFee,amount,prevAmount,policyId,txnId,refundReason,cardInfo})
  .pipe(map(user => { return user;
  })
);
}
  getUnderwritersLeadAgentCodes(leadsId){
    return this.http.get<any>(`${this.config.getUnderwriterLeadAgentCode+'/'+leadsId}`)
    .pipe(
        map(user => {
            return user;
        })
    );
  }
  updateAgreementStatus(leadId){
    //    (this.config.forgetPasswor)
    return this.http.get<any>(`${this.config.updateAgreementStatus+leadId}`)
    .pipe(
      map(user => {
          return user;
      })
  );
 }
  getmgaAgencyAll(){
    return this.http.get<any>(`${this.config.getAllAgencyMgas}`)
    .pipe(
      map(user => {
          return user;
      })
  );
}
  viewCOC(policyId:any){
    return this.http.get<any>(`${this.config.viewCOC}${policyId}`)
    .pipe(
        map(user => {
            return user;
        })
    );
  }
  getPolicyByIdSalesAdmin(policyId:any){
    return this.http.get<any>(`${this.config.getPolicyByIdSalesAdmin}${policyId}`)
    .pipe(
      map(user => {
          return user;
      })
  );
}
editBilling(cardType,id,policyId,sslCardNumber,sslCardShortDescription,sslCardType,sslCvv2Response,sslExpDate,sslTransactionType){
  
  return this.http.post<any>(`${this.config.editBilling}`,{cardType,id,policyId,sslCardNumber,sslCardShortDescription,sslCardType,sslCvv2Response,sslExpDate,sslTransactionType})
  .pipe(
      map(user => {
          return user;
      })
  );
}
getPolicyEmailSend(email:any,policyId:any){
  return this.http.post<any>(`${this.config.getPolicyEmailSend}`, {email,policyId})
  .pipe(
      map(user => {
          return user;
      })
  );
}
upadtePolicyInformation(contactInformation:any,policyId:any,purchaserInformation:any){
  return this.http.post<any>(`${this.config.upadtePolicyInformation}`, {contactInformation,policyId,purchaserInformation})
  .pipe(
      map(user => {
          return user;
      })
  );
}
addNoteInPolicy(noteText:any,policyId:any,type:any){
  return this.http.post<any>(`${this.config.addNoteInPolicy}`, {noteText,policyId,type})
  .pipe(
      map(user => {
          return user;
      })
  );
}
getNotesStatus(){
  return this.http.get<any>(`${this.config.getNotesStatus}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getAddressCanada1(primaryAddress1){
  return this.http.get<any>(`${this.config.AddressCallCanada+primaryAddress1+"?types=address&access_token=pk.eyJ1IjoidGVjaC10cmF2ZWxhbmNlIiwiYSI6ImNtOTc3MjB6NTA0a28yc3BxOWo1ZGtwZm8ifQ.jVlelsWJPgCitrVekZRT6g&streets=true&language=en&session_token=02e5c1ee-9e4d-4cf1-895d-20749d003310&country=ca"}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getAddressCanadaN(primaryAddress1,primaryAddress1c){
  return this.http.get<any>(`${this.config.AddressCallCanada+"Text="+primaryAddress1+"&Container="+primaryAddress1c+"&Origin="+"CAN"+"&Countries="+"CAN"+"&Datasets=&Filter=&Language=en&$block=true&$cache=true&SOURCE=PCA-SCRIPT&SESSION=3548a915-4b43-d9d3-762c-087d75ac7504"}`)
  .pipe(
      map(user => {
          return user;
      })
  );
}
getProvinceByBrokerId(leadId){
  return this.http.get<any>(`${this.config.getProvinceByBrokerId+leadId}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
        
          return user;
      })
  );
}
acceptAddendumAgentID(agentCodeId:any,isAddendumAccepted:any,leadId:any){
  return this.http.post<any>(`${this.config.acceptAddendumAgentID}`, {agentCodeId,isAddendumAccepted,leadId})
  .pipe(
      map(user => {
          return user;
      })
  );}
  getAllPolicyForSalesAdminByAgentId(agentId){
    return this.http.get<any>(`${this.config.getAllPolicyForSalesAdminByAgentId+agentId}`)
  .pipe(
      // the backend service sends an instance of the user
      map(user => {
        
          return user;
      })
  );
  }
  getSearchResultAsc(searchCriteria:any,page:any,size:any,nametable?:any){
    let url = `${this.config.getFilterSearchPolicyCallNew+'?page='+page+'&size='+size+'&sortBy='+nametable+'&sortDir=asc'}`;
    return this.http.post<any>(url, searchCriteria)
    .pipe(
        map(data => {
            return data;
        })
    );
  }
  getSearchResultDsc(searchCriteria:any,page:any,size:any,nametable?:any){
    let url = `${this.config.getFilterSearchPolicyCallNew+'?page='+page+'&size='+size+'&sortBy='+nametable+'&sortDir=desc'}`;
    return this.http.post<any>(url, searchCriteria)
    .pipe(
        map(data => {
            return data;
        })
    );
  }

  getPolicyHomePage(effectiveEndDate,effectiveStartDate,id){
    return this.http.post<any>(`${this.config.getPolicyHomePage}`, {effectiveEndDate,effectiveStartDate,id})
    .pipe(map(user => { return user;
    })
  );
  }
  deletePolicy(id){ 
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        "id": [id],
      }
    }
    return this.http.delete<any>(`${this.config.deletePolicy}`,options)
    .pipe(
        map(user => {    
            return user;
        })
    );
  }
  getLeadPreviewLinkSales(){
    return this.http.get<any>(`${this.config.PreviewLinkSales}`)
    .pipe(
        map(user => {
            return user;
        })
    );
  }
  getpolicyAsQuoteAndPrintEmail(policyId){
    return this.http.get<any>(`${this.config.getpolicyAsQuoteAndPrintEmail+policyId}`)
    .pipe(
        // the backend service sends an instance of the user
        map(user => {
          
            return user;
        })
    );
  }
  getSearchResultsavedquoteAsc(searchCriteria:any,page:any,size:any,nametable?:any){
    let url = `${this.config.filterSavedQuote+'?page='+page+'&size='+size+'&sort='+nametable+',asc'}`;
    return this.http.post<any>(url, searchCriteria)
    .pipe(
        map(data => {
            return data;
        })
    );
  }
  getSearchResultsavedquoteDsc(searchCriteria:any,page:any,size:any,nametable?:any){
    let url = `${this.config.filterSavedQuote+'?page='+page+'&size='+size+'&sort='+nametable+',desc'}`;
    return this.http.post<any>(url, searchCriteria)
    .pipe(
        map(data => {
            return data;
        })
    );
  }
 
  getAllSavedQuotesByAgentIdSavedQuote(searchCriteria:any,page:any,size:any,nametable?:any){
    let url = `${this.config.filterSavedQuote}?page=${page}&size=${size}`;
    if(nametable != null)
      url = url+'&sort='+nametable;
  
    return this.http.post<any>(url, searchCriteria)
    .pipe(
        map(data => {
            return data;
        })
    );
  }
  
  getAllSavedQuotesByAgentIdAsc(agentId:any,page:any,size:any,nametable?:any){
    return this.http.get<any>(`${this.config.getAllSavedQuotesByAgentId+ '/' +agentId+'?page='+page+'&size='+size+'&sort='+nametable+',asc'}`)
    .pipe(
        map(user => {
            return user;
        })
    );
  
  }
  getAllSavedQuotesByAgentIdDsc(agentId:any,page:any,size:any,nametable?:any){
    // let url = `${this.config.getAllSavedQuotesByAgentId+ '/' +agentId+'?page='+page+'&size='+size+'&sort='+nametable+',desc'}`;
    // return this.http.get<any>(url, searchCriteria)
    // .pipe(
    //     map(data => {
    //         return data;
    //     })
    // );
    return this.http.get<any>(`${this.config.getAllSavedQuotesByAgentId+ '/' +agentId+'?page='+page+'&size='+size+'&sort='+nametable+',desc'}`)
    .pipe(
        map(user => {
            return user;
        })
    );
  }
  getAllSavedQuotesByAgentIdPagechange(agentId:any,page:any,size:any){
    // let url = `${this.config.getAllSavedQuotesByAgentId+ '/' +agentId}?page=${page}&size=${size}`;
    // if(nametable != null)
    //   url = url+'&sort='+nametable;
  
    // return this.http.post<any>(url, searchCriteria)
    // .pipe(
    //     map(data => {
    //         return data;
    //     })
    // );
    return this.http.get<any>(`${this.config.getAllSavedQuotesByAgentId+ '/' +agentId}?page=${page}&size=${size}`)
    .pipe(
        map(user => {
            return user;
        })
    );
  }
  getAllSavedQuotesByAgentIdSavedQuotepagechange(searchCriteria:any,page:any,size:any,nametable?:any){
    let url = `${this.config.filterSavedQuote}?page=${page}&size=${size}`;
    if(nametable != null)
      url = url+'&sort='+nametable;
  
    return this.http.post<any>(url, searchCriteria)
    .pipe(
        map(data => {
            return data;
        })
    );
  }
  getCountryWithCode(){
    return this.http.get<any>(`${this.config.getCountryWithCode}`)
    .pipe(
        map(user => {
          return user;
        })
        );
      }
  getProvinceByAgentId(agentId){
    return this.http.get<any>(`${this.config.getProvinceByAgentId+agentId}`)
    .pipe(
        // the backend service sends an instance of the user
        map(user => {
          
            return user;
        })
    );
  }
  downloadFile(document_hash:any){
    return this.http.get<any>(`${this.config.downloadFile}${document_hash}`)
    .pipe(
      // the backend service sends an instance of the user
      map(user => {
         
          return user;
      })
    );
    }
    verifyToken(token:any,isPasswordReset:any,isBroker:any){
      return this.http.post<any>(`${this.config.verifyToken+token+'&isPasswordReset='+isPasswordReset+'&isBroker='+isBroker}`,{})
      .pipe(
      map(user => {
          return user;
      })
      );
    }
    getLeadInfoNew(){
      //    (this.config.forgetPasswor)
      return this.http.get<any>(`${this.config.getLeadInfoNew}`)
      .pipe(
        map(user => {
            return user;
        })
    );
  }
    changeUserPassword(email:any,password: any,confirmPassword: any,token: any){
      return this.http.post<any>(`${this.config.changeUserPassword}`, {email,password,confirmPassword,token})
      .pipe(
          map(user => {
              return user;
          })
      );
    }
    getProvince(){
      //    (this.config.forgetPasswor)
      return this.http.get<any>(`${this.config.getProvince}`)
      .pipe(
          map(user => {
              return user;
          })
      );
    }
    changeOldPassword(oldPassword:any,newPassword: any,email: any,token: any){
      return this.http.post<any>(`${this.config.changeOldPassword}`, {oldPassword,newPassword,email,token})
    }
    PreviewLinkVtc(){
      return this.http.get<any>(`${this.config.PreviewLinkVtc}`)
      .pipe(
        map(user => {
            return user;
        })
    );
  }
    getVtcQuotes(agentId:any,page:any,size:any){     
      return this.http.get<any>(`${this.config.getVtcQuotes+ '/' +agentId}?page=${page}&size=${size}`)
      .pipe(
          map(user => {
              return user;
          })
      );
    }
    DocmoreInfoReq(leadId){
      //    (this.config.forgetPasswor)
      return this.http.get<any>(`${this.config.DocmoreInfoReq+'?leadId='+leadId}`)
      .pipe(
        map(user => {
            return user;
        })
    );
  }
    calculatePremium(language:any){     
      return this.http.get<any>(`${this.config.calculatePremium}?language=${language}`)
      .pipe(
          map(user => {
              return user;
          })
      );
    }
    deletedocumentMga(documentId){ 
      return this.http.delete<any>(`${this.config.deletedocumentMga}${documentId}`)
      .pipe(
          map(user => {    
              return user;
          })
      );
    }
    getMGAdocument(mgaId,leadId){
      return this.http.get<any>(`${this.config.getMGAdocument+'MGA'+'/'+mgaId+'/lead/'+leadId}`)
      .pipe(
          // the backend service sends an instance of the user
          map(user => {
    
              return user;
          })
      );
    }
    checkLinkValid(token: any){
      return this.http.get<any>(`${this.config.checkLinkValid+token}`)
    }
    getTransferAgencyCode(leadId:string){
      return this.http.get<any>(`${this.config.getTransferAgencyCode}${leadId}`)
      .pipe(
        map(user => {
            return user;
        })
    );
  }
    getSavedQuotesByIdVTC(Id){
      return this.http.get<any>(`${this.config.getSavedQuotesByIdVTC + Id}`)
      .pipe(
          map(user => {
              return user;
          })
      );
    }
    acceptBrokerStatement(date){
      //    (this.config.forgetPasswor)
      return this.http.post<any>(`${this.config.acceptBrokerStatement}`,{date})
      .pipe(
          map(user => {
              return user;
          })
      );
    }
    downloadLeadsDocs(leadId){
      return this.http.get<any>(`${this.config.downloadLeadsDocs+leadId}`)
      .pipe(
          // the backend service sends an instance of the user
          map(user => {
            
              return user;
          })
      );
    }
    getLastTrainingDate(type:any,id:any){
      //    (this.config.forgetPasswor)
      return this.http.get<any>(`${this.config.getLastTrainingDate+type+'/'+id}`)
      .pipe(
        map(user => {
            return user;
        })
    );
  }
    getVTCPlanNames(planName){
      return this.http.get<any>(`${this.config.getVTCPlanNames + planName}`)
      .pipe(
          map(user => {
              return user;
          })
      );
    }
    OADeactivateLeads(leadId: any){
      return this.http.post<any>(`${this.config.OADeactivateBrokerleads}`, {leadId})
      .pipe(
      map(user => {
          return user;
      })
      );
    }
    OADeactivateLeadsMultiple(leadIds: any){
      return this.http.post<any>(`${this.config.OADeactivateBrokerleadsMultiple}`, {leadIds})
      .pipe(
        map(user => {
            return user;
        })
    );
  }
    acceptisprates(){
      //    (this.config.forgetPasswor)
      return this.http.get<any>(`${this.config.acceptisprates}`)
      .pipe(
          map(user => {
              return user;
          })
      );
    }
    getMgaOVRBalanceOwing(leadId){
      return this.http.get<any>(`${this.config.MgaOVRBalanceOwing+leadId}`)
      .pipe(
          // the backend service sends an instance of the user
          map(user => {
            
              return user;
          })
      );
    }
    getLeadBySizeSearch(page:any,size: any){

      return this.http.get<any>(`${this.config.sizeWiseLeads+page+'&size='}${size}`)
      .pipe(
          // the backend service sends an instance of the user
          map(user => {
             
              return user;
          })
      );
    }
    acceptPortalAnnouncement(){
      //    (this.config.forgetPasswor)
      return this.http.get<any>(`${this.config.acceptPortalAnnouncement}`)
      .pipe(
          map(user => {
              return user;
          })
      );
    }
    // getDashboardData1() {
    //   const token = JSON.parse(localStorage.getItem('currentToken') || '""');
    //   // const token = localStorage.getItem('currentToken'); // or whatever key you used
    //   const headers = new HttpHeaders({
    //     'Authorization': `Bearer ${token}`
    //   });
    
    //   return this.http.get<any>(`${this.config.dashboardapiurl1}`, { headers });
    // }
    // DocmoreInfoReq(leadId: string) {
    //   const token = JSON.parse(localStorage.getItem('currentToken') || '""');
    //   const headers = new HttpHeaders({
    //     'Authorization': `Bearer ${token}`
    //   });
    
    //   return this.http.get<any>(`${this.config.DocmoreInfoReq}?leadId=${leadId}`, { headers })
    //     .pipe(
    //       map(user => {
    //         return user;
    //       })
    //     );
    // }
    addUpdateSIN(leadId: any,requestedId: any,sinNumber: any){
      return this.http.post<any>(`${this.config.addUpdateSIN+'?requestedId='+requestedId+'&sinNumber='+sinNumber+'&leadId='+leadId}`,{})
      .pipe(
          map(user => {
              return user;
          })
      );
    }
  addLeads(salutation: any,workPhoneExtension:any,countTraining: any,firstName: any,middleName: any,
  primaryCompleteAddress: any,lastName: any,primaryAddressCountry: any,primaryAddressCity: any,
  primaryAddressProvince: any,leadStatus: any,primaryAddressPostalCode: any,userId: any,
  alternativeCompleteAddress: any,type: any,alternativeAddressCountry: any,languages: any,
  alternativeAddressCity: any,leadSource: any,ciprnumber: string,productSelling: any,positionTitle: any,
  alternativeAddressProvince: any,agencyMgaId: any,alternativeAddressPostalCode: any,workPhone: string,
  mobileNumber: string,leadMailCompanian: any,emailAddress: any,leadSubSource: any,website: any,tags: any,
  leadEmailAddress: any,allProvicesList:any,firstSignUpDate:any,
  consentStatus:any,
  proofOfConsent :any,
  adminOnly:any,
  consentDate:any,

  countCalls:any,
  countTasks:any,
  dncStatus:any,
  agentNurtureStatus:any,
  residentLicenseExpiryDate:any,
  residentProvince:any,
  userID:any,
  password:any,
  myTravelLink:any,
  representingCompanies:any,
  otherPhone:any,
  fax:any,
  homePhone:any,
  caslOptOut:boolean,
  title:any,
  agencyAdditionalOffices:any,residentAddressBeans:any,
  agencyCode:any,
  companyName:any,
  leadSourceOther:any,
  canTrainingOverride:any,
  licencesType:any,myTravelLinkRequest:any,jumpStart:any,specialBonus:any,
  wfgCode:any,
  isCompanySignup:any,
  commissionTo:any,secondaryEmailAddress:any,
  agencyId:any
  ){
  return this.http.post<any>(`${this.config.addLeads}`, {salutation,workPhoneExtension,countTraining, firstName,middleName,primaryCompleteAddress,lastName,primaryAddressCountry,primaryAddressCity,primaryAddressProvince,leadStatus,primaryAddressPostalCode,userId,alternativeCompleteAddress,type,alternativeAddressCountry,languages,alternativeAddressCity,leadSource,ciprnumber,productSelling,positionTitle,alternativeAddressProvince,agencyMgaId,alternativeAddressPostalCode,workPhone,mobileNumber,leadMailCompanian,emailAddress,leadSubSource,website,tags,leadEmailAddress,allProvicesList,
    firstSignUpDate,
    consentStatus,
    proofOfConsent,
    adminOnly,
    consentDate,

    countCalls,
    countTasks,
    dncStatus,
    agentNurtureStatus,
    residentLicenseExpiryDate,
    residentProvince,
    userID,
    password,
    myTravelLink,
    representingCompanies,
    otherPhone,
    fax,
    homePhone,
    caslOptOut,
    title,
    agencyAdditionalOffices,
    residentAddressBeans,
    agencyCode,
companyName,
leadSourceOther,
canTrainingOverride,
licencesType,
myTravelLinkRequest,
jumpStart,
specialBonus,
wfgCode,
isCompanySignup,
commissionTo,
secondaryEmailAddress,
agencyId
  })
  .pipe(

      map(user => {

          return user;
      })
  );
}
getV3RecaptchaVerification(recaptchaToken:any){
      return this.http.post<any>(`${this.config.getV3RecaptchaVerification}`, {recaptchaToken})
      .pipe(map(user => { return user;
          })
      );
     }
annualConfirmationPopup(leadId: number) {
  const url = `${this.config.annualTrainingConfirmation}?leadId=${leadId}`;
  return this.http.get<any>(url).pipe(
    map(user => {
      // Optionally transform user data here
      return user;
    })
  );
}
annualConfirmationPopupAction(relatedToId: number,relatedToName:any,action:any,optOutDays:any,brokerName:any){
  return this.http.post<any>(`${this.config.annualTrainingConfirmationAction}`, {relatedToId,relatedToName,action,optOutDays,brokerName})
  .pipe(
  map(user => {
      return user;
  })
  );
}
}

